import React, { useRef, useState } from 'react'
import { Table } from 'antd'
import { AvailableLimitProps } from './interface'
import { useRequest } from '@sisyphe/hooks'
import * as api from 'services/user'
import { columns } from './config'
import './index.less'

type PageProps = { pageNum: number; pageSize: number }

export default function AvailableLimit(props: AvailableLimitProps) {
  const [total, setTotal] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)

  const pageRef = useRef<PageProps>({ pageNum: 1, pageSize: 10 })

  /*个人帐号信息-可用额度 */
  const {
    run: queryUserQuotaUsingPOST,
    data,
    loading,
  } = useRequest(async (params = {}) => {
    const { data } = await api.queryUserQuotaUsingPOST({
      ...pageRef.current,
      ...params,
    })
    setTotal(data?.total)
    setTotalAmount(data?.totalAmount)
    return data?.quotaQueryInfoDTOS
  })

  return (
    <div className="id-available-limit">
      <div className="limit-h">
        <p className="limit-t">当前可用额度</p>
        <p className="limit-a">{totalAmount?.toFixed(2)}</p>
      </div>
      <div className="limit-table">
        <p className="limit-t">当前可用额度</p>
        <Table
          loading={loading}
          columns={columns}
          dataSource={data || []}
          pagination={{
            total,
            current: pageRef.current.pageNum,
            pageSize: pageRef.current.pageSize,
            showQuickJumper: true,
            showTotal: total => `总数 ${total} 条`,
            onChange(page, pageSize) {
              pageRef.current.pageNum = page
              pageRef.current.pageSize = pageSize
              queryUserQuotaUsingPOST()
            },
          }}
        />
      </div>
    </div>
  )
}
